import React from 'react';
import { RegularMetricId } from '../../../../api/types-graphql';
import { ExternalChartComponentProps } from '../../../../common/components/data-viz-containers/common/types';
import { KpiFactboxSingleMetricViz } from '../../../../common/components/data-viz-containers/kpi-factbox-single-metric/SingleMetricKpiFactboxViz';
import {
  KpiFactboxSingleMetricVizConfig,
  KpiFactboxSingleMetricVizViews,
} from '../../../../common/components/data-viz-containers/kpi-factbox-single-metric/types';
import { Languages } from '../../../../constants';
import { SingleValueTimeSelection } from '../../../../types';

export const ApplicationsAtHiredFactbox = (props: {
  timeSelection: SingleValueTimeSelection;
  externalProps: ExternalChartComponentProps;
  filters?: string;
}) => {
  const { timeSelection, externalProps, filters } = props;
  const offerAcceptedFactboxConfig: KpiFactboxSingleMetricVizConfig = {
    title: {
      [Languages.EN]: '2025年度内定承諾数（人）',
      [Languages.JA]: '2025年度内定承諾数（人）',
    },
    section: {
      query: {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0276_1ApplicationsAtHiredCount,
        },
        timeSelection,
        filters,
      },
    },
  };
  return (
    <KpiFactboxSingleMetricViz
      dataConfig={offerAcceptedFactboxConfig}
      selectedView={KpiFactboxSingleMetricVizViews.FACTBOX}
      externalProps={externalProps}
      persistenceKey={`new-grad-recruitment-applications-at-hired-factbox-${filters ?? ''}`}
    />
  );
};
